import  gql  from 'graphql-tag'

export const REVOKE_TOKEN = gql`mutation revokeToken($input: RevokeInput!){
    revokeToken(input: $input){
        revoked
    }
}`;